import { useDeviceCondition } from '../../../../../../hooks';
import { InlineText1, InlineText2, Spinner } from '@cian/ui-kit';
import * as styles from '../../PaymentStatus.css';
import * as React from 'react';

export const PaymentStatusPending = () => {
  const InlineText = useDeviceCondition(InlineText2, InlineText1);

  return (
    <>
      <Spinner size={16} />
      <div className={styles['text']}>
        <InlineText>Выполнение платежа</InlineText>
      </div>
    </>
  );
};
